import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const SLIDES = [
    {
        url: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=1920&q=80",
        alt: "Audience before the silver screen",
    },
    {
        url: "https://images.unsplash.com/photo-1594908900066-3f47337549d8?w=1920&q=80",
        alt: "Classic cinema hall with velvet curtain",
    },
    {
        url: "https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1920&q=80",
        alt: "35mm film strip",
    },
    {
        url: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=1920&q=80",
        alt: "Neon marquee at night",
    },
    {
        url: "https://images.unsplash.com/photo-1507676184212-d03ab07a01bf?w=1920&q=80",
        alt: "Stage under a single spotlight",
    },
];

const INTERVAL_MS = 6000;

export default function HeroCarousel() {
    const [i, setI] = useState(0);

    // preload next image for a buttery crossfade
    useEffect(() => {
        const next = new Image();
        next.src = SLIDES[(i + 1) % SLIDES.length].url;
    }, [i]);

    useEffect(() => {
        const id = setInterval(() => {
            setI((prev) => (prev + 1) % SLIDES.length);
        }, INTERVAL_MS);
        return () => clearInterval(id);
    }, []);

    return (
        <div className="absolute inset-0 z-0 overflow-hidden" aria-hidden="true">
            <AnimatePresence mode="sync">
                <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 1.08 }}
                    animate={{ opacity: 1, scale: 1.02 }}
                    exit={{ opacity: 0 }}
                    transition={{
                        opacity: { duration: 1.4, ease: "easeInOut" },
                        scale: { duration: INTERVAL_MS / 1000, ease: "linear" },
                    }}
                    className="absolute inset-0"
                    style={{ willChange: "transform, opacity" }}
                >
                    <img
                        src={SLIDES[i].url}
                        alt={SLIDES[i].alt}
                        className="w-full h-full object-cover"
                        loading="eager"
                    />
                </motion.div>
            </AnimatePresence>

            {/* scrims for text legibility */}
            <div className="absolute inset-0 bg-gradient-to-b from-ink-300/30 via-ink-300/50 to-ink-300 pointer-events-none" />
            <div className="absolute inset-0 bg-gradient-to-r from-ink-300/75 via-ink-300/30 to-transparent pointer-events-none" />
        </div>
    );
}
